import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');

import Card from '../Shared/Card';

const Publication_Item = (props) => (
      <PubCard >
        <PublicationTitle>{props.pub.title}</PublicationTitle>
        <PublicationAuthors>{props.pub.authors.map((author, i) => {
          if (author === 'A.E. Zimmerman' || author === 'Zimmerman' || author === 'A.E.') {
            return (
              <strong key={i}>
                {author}
                {props.pub.authors.length -1 > i ? ', ' : ''}
              </strong>)
          } else {
            return (
              <span key={i}>
                {author}
                {props.pub.authors.length -1 > i ? ', ' : ''}
              </span>)
          }

        })}</PublicationAuthors>
        <PublicationDetails>
          <span>{props.pub.year}</span>
          <span> – </span>
          <span>{props.pub.journal}</span>
          <span> – </span>
          <ALink href={props.pub.abstractUrl}
                 target='_blank'>
                 {props.pub.doiNumber}
          </ALink>
        </PublicationDetails>
      </PubCard>
);

export default Publication_Item;


const PubCard = Card.extend`
  margin: 0px 0px 10px;
  &:last-of-type {
    margin-bottom: 20px;
  }
`;

const ALink = styled.a`
  text-decoration: none;
  color: #333;
  ${PubCard}:hover & {
    color: seagreen;
    text-decoration: underline;
  }
  ${'' /* &:hover {
    color: seagreen;
  } */}

`;

const PublicationTitle = styled.h2`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
`

const PublicationAuthors = styled.p`
  line-height: 1.5rem;
  font-size: 1rem;
  margin: 0px 0px .5rem;
  font-weight: 500;
  opacity: 0.8;
`;

const PublicationDetails = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0px 0px 0;
  opacity: 0.8;
  & p:last-of-type {
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Publication_Item/index.js